import React from 'react';
import { List, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { StyledDrawer, StyledListItemButton, StyledListItemText, StyledListItemIcon } from './SideBar.styles';
import { useVenueRole } from '../../utils/Hooks/useVenueRole';
import { useSelector } from 'react-redux';
import { MENU_ITEMS, ROLES, PROTECTED_MENU_ITEMS } from './SideBar.constants';

const SideBar = () => {
  const venueId = useSelector((state) => state.currentUser.venue.id);
  const { role } = useVenueRole(venueId);

  return (
    <StyledDrawer variant="permanent">
      <List disablePadding>
        {MENU_ITEMS.map((item) => (
          <StyledListItemButton key={item.text} component={NavLink} to={item.path}>
            <StyledListItemIcon>
              <item.icon />
            </StyledListItemIcon>
            <StyledListItemText
              primary={
                <Typography variant="navBar" align="center">
                  {item.text}
                </Typography>
              }
            />
          </StyledListItemButton>
        ))}
        {(role === ROLES.OWNER || role === ROLES.MANAGER) &&
          PROTECTED_MENU_ITEMS.map((item) => (
            <StyledListItemButton key={item.text} component={NavLink} to={item.path}>
              <StyledListItemIcon>
                <item.icon />
              </StyledListItemIcon>
              <StyledListItemText
                primary={
                  <Typography variant="navBar" align="center">
                    {item.text}
                  </Typography>
                }
              />
            </StyledListItemButton>
          ))}
      </List>
    </StyledDrawer>
  );
};

export default SideBar;
